import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';
import {FeatureEventData, slotStore} from '@gongxigames/framework/slotV2/globals';
import {listenUIDisabled} from '@gongxigames/framework/slotV2/ui/acts/utils';

export class FreeGameUIAct extends SyncUIActDecorator {
    protected shouldUpdateFGCounter = true;

    public execute(): void {
        listenUIDisabled(this);

        this.emitter.once('Game.command.round.featureAccepted', () => {
            this.emitter.emit('UI.playTransitionToFreeSpins');
            this.emitter.emit('Game.command.buyFeature.hide');
            this.updateFGCounter(false);
        });
        this.emitter.on('Game.command.reels.started', () => {
            this.updateFGCounter();
        });
        this.emitter.on('UI.quickStopButton.pressed', this.onQuickStopButtonPressed.bind(this));
        this.emitter.on('UI.skipButton.pressed', this.onSkipButtonPressed.bind(this));
        this.emitter.emit('General.disableSpinButton');
        this.emitter.emit('UI.updateUIElementsState', 'FreeGameUIState');
        this.emitter.on('Game.command.round.featureStopped', (data: FeatureEventData) => {
            if (data.type === 'freeSpins') {
                slotStore.batchUpdate({
                    feature_type: null
                });
                this.emitter.emit('UI.playTransitionToMainGame');
                this.onExecuted?.();
            } else {
                this.shouldUpdateFGCounter = true;
            }
        });
        this.emitter.on('Game.command.round.featureStarted', (data: FeatureEventData) => {
            if (data.type !== 'freeSpins') {
                this.shouldUpdateFGCounter = false;
                slotStore.batchUpdate({
                    feature_type: data
                });
                this.onExecuted?.();
            }
        });
    }

    protected onQuickStopButtonPressed(): void {
        this.emitter.emit('UI.command.spin');
    }

    protected onSkipButtonPressed(): void {
        this.emitter.emit('UI.command.spin');
    }

    protected updateFGCounter(isItStartOfNextFS = true): void {
        if (!this.shouldUpdateFGCounter) {
            return;
        }
        const offset = isItStartOfNextFS ? 1 : 0;

        this.emitter.emit('General.FreeGames.UpdateCounter', {
            left: slotStore.logic_freeGamesTotalCount.value - slotStore.logic_freeGamesCount.value + offset,
            total: slotStore.logic_freeGamesTotalCount.value
        });
    }

    getName(): string {
        return 'FreeGameUIAct';
    }
}